import request from '@/utils/request'
//列表展示
export function fetchList(params) {
  return request({
    url:'Shop.Point/showpoin',
    method:'get',
    params:params
  })
}
export function showcommodity(params) {
  return request({
    url:'Shop.Point/showcommodity',
    method:'get',
    params:params
  })
}
// 积分兑换
export function showcoin(params) {
  return request({
    url:'Shop.Point/coin',
    method:'post',
    data: params
  })
}

// 每日签到
export function dailysign(params) {
  return request({
    url:'Shop.Point/dailysign',
    method:'get',
    params:params
  })
}
// 我的积分/菲尔币
export function myPoint(params) {
  return request({
    url:'Shop.Point/details',
    method:'get',
    params: params
  })
}



// 生成购物订单
export function PointscartOrder(data) {
  return request({
    url:'Shop.Pointscart/orders_create',
    method:'post',
    data: data
  })
}
// 购物车展示
export function PointscartList(params) {
  return request({
    url:'Shop.Pointscart/index',
    method:'get',
    params: params
  })
}
// 修改
export function PointscartEdi(params) {
  return request({
    url:'Shop.Pointscart/edi',
    method:'get',
    params: params
  })
}
// 删除
export function PointscartDel(params) {
  return request({
    url:'Shop.Pointscart/del',
    method:'get',
    params: params
  })
}
// 清空购物车
export function PointscartDelAll(params) {
  return request({
    url:'Shop.Pointscart/delall',
    method:'get',
    params: params
  })
}
// 加入购物车
export function addPointscart(data) {
  return request({
    url:'Shop.Pointscart/add',
    method:'post',
    data: data
  })
}
// 积分订单详情 id
export function getPointDetail(data) {
  return request({
    url:'Shop.Pointscart/getPointDetail',
    method:'get',
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/api/integralShop.js